// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gatendar Cat Theme Styles 🐱 */

:root {
  /* Cat-friendly color palette */
  --cat-pink: #FF6B9D;
  --cat-purple: #9B59B6;
  --cat-orange: #FF9A56;
  --cat-cream: #FFF5F8;
  --cat-lavender: #E8D5F2;
  --cat-teal: #4ECDC4;

  /* Gradient backgrounds */
  --cat-gradient-primary: linear-gradient(135deg, #FF6B9D 0%, #9B59B6 100%);
  --cat-gradient-warm: linear-gradient(135deg, #FF9A56 0%, #FF6B9D 100%);
  --cat-gradient-cool: linear-gradient(135deg, #4ECDC4 0%, #9B59B6 100%);
}

/* Dark mode styles */
[data-theme="dark"] {
  --cat-pink: #FF8FB1;
  --cat-purple: #B07CC6;
  --cat-orange: #FFB380;
  --cat-cream: #2D2D2D;
  --cat-lavender: #3D2D4D;
  --cat-teal: #5FCFC4;
}

/* Dark mode scrollbar */
@media (prefers-color-scheme: dark) {
  ::-webkit-scrollbar-track {
    background: #1E1E1E;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #FF8FB1 0%, #B07CC6 100%);
  }
}

/* Force dark mode scrollbar when dark mode is active */
body.dark-mode {
  --cat-pink: #FF8FB1;
  --cat-purple: #B07CC6;
  --cat-orange: #FFB380;
  --cat-cream: #2D2D2D;
  --cat-lavender: #3D2D4D;
  --cat-teal: #5FCFC4;
}

body.dark-mode ::-webkit-scrollbar-track {
  background: #1E1E1E;
}

body.dark-mode ::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #FF8FB1 0%, #B07CC6 100%);
}

/* Cat paw print background pattern */
.cat-paw-background {
  position: relative;
  overflow: hidden;
}

.cat-paw-background::before {
  content: '🐾';
  position: absolute;
  font-size: 120px;
  opacity: 0.03;
  top: -20px;
  right: -20px;
  transform: rotate(-15deg);
  pointer-events: none;
  z-index: 0;
}

.cat-paw-background::after {
  content: '🐾';
  position: absolute;
  font-size: 80px;
  opacity: 0.03;
  bottom: 20px;
  left: 20px;
  transform: rotate(25deg);
  pointer-events: none;
  z-index: 0;
}

/* Animated cat paw prints trail */
@keyframes paw-trail {
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
    transform: scale(1.5) rotate(20deg);
  }
}

.cat-paw-trail {
  animation: paw-trail 2s ease-out infinite;
}

/* Cat-themed loading animation */
@keyframes cat-bounce {

  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  25% {
    transform: translateY(-10px) rotate(-5deg);
  }

  75% {
    transform: translateY(-5px) rotate(5deg);
  }
}

.cat-loading {
  display: inline-block;
  font-size: 3rem;
  animation: cat-bounce 1.5s ease-in-out infinite;
}

/* Purr effect - subtle vibration on hover */
@keyframes purr {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-1px);
  }

  75% {
    transform: translateX(1px);
  }
}

.cat-purr:hover {
  animation: purr 0.3s ease-in-out infinite;
}

/* Cat ear wiggle animation */
@keyframes ear-wiggle {

  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-5deg);
  }

  75% {
    transform: rotate(5deg);
  }
}

.cat-wiggle {
  display: inline-block;
  animation: ear-wiggle 2s ease-in-out infinite;
}

/* Cat-themed button styles */
.cat-button {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.cat-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 107, 157, 0.3);
}

.cat-button::before {
  content: '🐱';
  position: absolute;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  opacity: 0;
  transition: all 0.3s ease;
}

.cat-button:hover::before {
  left: 10px;
  opacity: 1;
}

/* Cat card hover effect */
.cat-card {
  transition: all 0.3s ease;
  position: relative;
}

.cat-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 12px 30px rgba(155, 89, 182, 0.2);
}

/* Meow text effect */
@keyframes meow-pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.cat-meow {
  animation: meow-pulse 2s ease-in-out infinite;
}

/* Cat emoji decorations */
.cat-emoji-large {
  font-size: 4rem;
  display: inline-block;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.cat-emoji-medium {
  font-size: 2.5rem;
  display: inline-block;
}

.cat-emoji-small {
  font-size: 1.5rem;
  display: inline-block;
}

/* Gradient text for cat theme */
.cat-gradient-text {
  background: var(--cat-gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: bold;
}

/* Cat-themed scrollbar */
::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: var(--cat-cream);
}

::-webkit-scrollbar-thumb {
  background: var(--cat-gradient-primary);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--cat-purple);
}

/* Floating cat animation */
@keyframes float-cat {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px);
  }
}

.cat-float {
  animation: float-cat 3s ease-in-out infinite;
}

/* Cat paw cursor trail effect */
.cat-cursor-trail {
  pointer-events: none;
  position: fixed;
  font-size: 20px;
  animation: paw-trail 1s ease-out forwards;
}`, "",{"version":3,"sources":["webpack://./src/cat-theme.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;;EAEnB,yBAAyB;EACzB,yEAAyE;EACzE,sEAAsE;EACtE,sEAAsE;AACxE;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;;EAEE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,+CAA+C;AACjD;;AAEA,4CAA4C;AAC5C;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;;EAEE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;;EAEE;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C","sourcesContent":["/* Gatendar Cat Theme Styles 🐱 */\r\n\r\n:root {\r\n  /* Cat-friendly color palette */\r\n  --cat-pink: #FF6B9D;\r\n  --cat-purple: #9B59B6;\r\n  --cat-orange: #FF9A56;\r\n  --cat-cream: #FFF5F8;\r\n  --cat-lavender: #E8D5F2;\r\n  --cat-teal: #4ECDC4;\r\n\r\n  /* Gradient backgrounds */\r\n  --cat-gradient-primary: linear-gradient(135deg, #FF6B9D 0%, #9B59B6 100%);\r\n  --cat-gradient-warm: linear-gradient(135deg, #FF9A56 0%, #FF6B9D 100%);\r\n  --cat-gradient-cool: linear-gradient(135deg, #4ECDC4 0%, #9B59B6 100%);\r\n}\r\n\r\n/* Dark mode styles */\r\n[data-theme=\"dark\"] {\r\n  --cat-pink: #FF8FB1;\r\n  --cat-purple: #B07CC6;\r\n  --cat-orange: #FFB380;\r\n  --cat-cream: #2D2D2D;\r\n  --cat-lavender: #3D2D4D;\r\n  --cat-teal: #5FCFC4;\r\n}\r\n\r\n/* Dark mode scrollbar */\r\n@media (prefers-color-scheme: dark) {\r\n  ::-webkit-scrollbar-track {\r\n    background: #1E1E1E;\r\n  }\r\n\r\n  ::-webkit-scrollbar-thumb {\r\n    background: linear-gradient(135deg, #FF8FB1 0%, #B07CC6 100%);\r\n  }\r\n}\r\n\r\n/* Force dark mode scrollbar when dark mode is active */\r\nbody.dark-mode {\r\n  --cat-pink: #FF8FB1;\r\n  --cat-purple: #B07CC6;\r\n  --cat-orange: #FFB380;\r\n  --cat-cream: #2D2D2D;\r\n  --cat-lavender: #3D2D4D;\r\n  --cat-teal: #5FCFC4;\r\n}\r\n\r\nbody.dark-mode ::-webkit-scrollbar-track {\r\n  background: #1E1E1E;\r\n}\r\n\r\nbody.dark-mode ::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(135deg, #FF8FB1 0%, #B07CC6 100%);\r\n}\r\n\r\n/* Cat paw print background pattern */\r\n.cat-paw-background {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.cat-paw-background::before {\r\n  content: '🐾';\r\n  position: absolute;\r\n  font-size: 120px;\r\n  opacity: 0.03;\r\n  top: -20px;\r\n  right: -20px;\r\n  transform: rotate(-15deg);\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n.cat-paw-background::after {\r\n  content: '🐾';\r\n  position: absolute;\r\n  font-size: 80px;\r\n  opacity: 0.03;\r\n  bottom: 20px;\r\n  left: 20px;\r\n  transform: rotate(25deg);\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n/* Animated cat paw prints trail */\r\n@keyframes paw-trail {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0) rotate(0deg);\r\n  }\r\n\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(1.5) rotate(20deg);\r\n  }\r\n}\r\n\r\n.cat-paw-trail {\r\n  animation: paw-trail 2s ease-out infinite;\r\n}\r\n\r\n/* Cat-themed loading animation */\r\n@keyframes cat-bounce {\r\n\r\n  0%,\r\n  100% {\r\n    transform: translateY(0) rotate(0deg);\r\n  }\r\n\r\n  25% {\r\n    transform: translateY(-10px) rotate(-5deg);\r\n  }\r\n\r\n  75% {\r\n    transform: translateY(-5px) rotate(5deg);\r\n  }\r\n}\r\n\r\n.cat-loading {\r\n  display: inline-block;\r\n  font-size: 3rem;\r\n  animation: cat-bounce 1.5s ease-in-out infinite;\r\n}\r\n\r\n/* Purr effect - subtle vibration on hover */\r\n@keyframes purr {\r\n\r\n  0%,\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  25% {\r\n    transform: translateX(-1px);\r\n  }\r\n\r\n  75% {\r\n    transform: translateX(1px);\r\n  }\r\n}\r\n\r\n.cat-purr:hover {\r\n  animation: purr 0.3s ease-in-out infinite;\r\n}\r\n\r\n/* Cat ear wiggle animation */\r\n@keyframes ear-wiggle {\r\n\r\n  0%,\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  25% {\r\n    transform: rotate(-5deg);\r\n  }\r\n\r\n  75% {\r\n    transform: rotate(5deg);\r\n  }\r\n}\r\n\r\n.cat-wiggle {\r\n  display: inline-block;\r\n  animation: ear-wiggle 2s ease-in-out infinite;\r\n}\r\n\r\n/* Cat-themed button styles */\r\n.cat-button {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.cat-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(255, 107, 157, 0.3);\r\n}\r\n\r\n.cat-button::before {\r\n  content: '🐱';\r\n  position: absolute;\r\n  left: -30px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 1.2rem;\r\n  opacity: 0;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.cat-button:hover::before {\r\n  left: 10px;\r\n  opacity: 1;\r\n}\r\n\r\n/* Cat card hover effect */\r\n.cat-card {\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.cat-card:hover {\r\n  transform: translateY(-5px) scale(1.02);\r\n  box-shadow: 0 12px 30px rgba(155, 89, 182, 0.2);\r\n}\r\n\r\n/* Meow text effect */\r\n@keyframes meow-pulse {\r\n\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n\r\n  50% {\r\n    opacity: 0.8;\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n.cat-meow {\r\n  animation: meow-pulse 2s ease-in-out infinite;\r\n}\r\n\r\n/* Cat emoji decorations */\r\n.cat-emoji-large {\r\n  font-size: 4rem;\r\n  display: inline-block;\r\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.cat-emoji-medium {\r\n  font-size: 2.5rem;\r\n  display: inline-block;\r\n}\r\n\r\n.cat-emoji-small {\r\n  font-size: 1.5rem;\r\n  display: inline-block;\r\n}\r\n\r\n/* Gradient text for cat theme */\r\n.cat-gradient-text {\r\n  background: var(--cat-gradient-primary);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Cat-themed scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 12px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--cat-cream);\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--cat-gradient-primary);\r\n  border-radius: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--cat-purple);\r\n}\r\n\r\n/* Floating cat animation */\r\n@keyframes float-cat {\r\n\r\n  0%,\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n.cat-float {\r\n  animation: float-cat 3s ease-in-out infinite;\r\n}\r\n\r\n/* Cat paw cursor trail effect */\r\n.cat-cursor-trail {\r\n  pointer-events: none;\r\n  position: fixed;\r\n  font-size: 20px;\r\n  animation: paw-trail 1s ease-out forwards;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
